<template>
    <form>
        <div class="form-group">
            <label>Email address</label>
            <input type="email" class="form-control" placeholder="Enter your email address">
        </div>
        <div class="form-group">
            <div class="d-flex justify-content-between mg-b-5">
                <label class="mg-b-0-f">Password</label>
            </div>
            <input type="password" class="form-control" placeholder="Enter your password">
        </div>
        <div class="form-group">
            <label>Firstname</label>
            <input type="text" class="form-control" placeholder="Enter your firstname">
        </div>
        <div class="form-group">
            <label>Lastname</label>
            <input type="text" class="form-control" placeholder="Enter your lastname">
        </div>
        <div class="form-group tx-12">
            By clicking <strong>Create an account</strong> below, you agree to our terms of service and privacy statement.
        </div><!-- form-group -->

        <button class="btn btn-brand-02 btn-block">Create Account</button>
    </form>
</template>

<script>
    export default {
        name: "RegisterForm"
    }
</script>

<style scoped>

</style>